export class DocumentHelper {
    public static isFileTypeSupportedForPreview(fileType : string) {
	fileType = fileType.toLowerCase();

	return fileType == "hpgl" || fileType == "hpg" || fileType == "plt" || fileType == "pdf";            
    }
}
